export default __webpack_public_path__ + "static/media/sec3.1b69c19d.png";